import { InputHTMLAttributes } from "react";

import { EIconReceiptType } from "./EIconReceiptType";
import IdentityCard from "../../../../svg/IdentityCard";
import Card from "../../../../svg/Card";
import House from "../../../../svg/House";
import Document from "../../../../svg/Document";
import Upload from "../../../../svg/Upload";
import Download from "../../../../svg/Download";
import Eye from "../../../../svg/Eye";
import Cross from "../../../../svg/Cross";
import ArrowDown from "../../../../svg/ArrowDown";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  type: EIconReceiptType | string | undefined
  color?: string | undefined
}

const IconReceipt = ({ type, color, ...props }: IProps): JSX.Element => {
  switch (type) {
    case EIconReceiptType.IDENTITY_CARD:
      return <IdentityCard color={color ?? "var(--ink-1)"} {...props} />
    case EIconReceiptType.CARD:
      return <Card color={color ?? "var(--ink-1)"} {...props} />
    case EIconReceiptType.ADDRESS_PROOF:
      return <House color={color ?? "var(--ink-1)"} {...props} />

    case EIconReceiptType.UPLOAD:
      return <Upload color={color ?? "var(--ink-1)"} {...props} />
    case EIconReceiptType.DOWNLOAD:
      return <Download color={color ?? "var(--ink-1)" } {...props}/>
    case EIconReceiptType.EYE:
      return <Eye color={color ?? "var(--ink-1)" } {...props}/>
    case EIconReceiptType.CROSS:
      return <Cross color={color ?? "var(--ink-1)" } {...props}/>
    case EIconReceiptType.ARROW_DOWN:
      return <ArrowDown color={color ?? "var(--ink-1)" } {...props}/>
    
    default:
      return <Document color={color ?? "var(--ink-1)"} {...props} />
  }
}

export default IconReceipt
